// Панель «Связи» (кнопка переименована владельцем вечером 2026-10-06, была «Типовой этаж») на «Модели ГПР» (владелец 2026-10-05: «сделать типовой этаж прямо
// в модели ГПР, чтобы не переключаться между экранами, и все типовые связи задавать там»).
// Первая версия — мини-Гант цикла по длительностям — владельцу не подошла («какая-то ерунда»),
// заменена той же схемой, что на экране «Связи», только с поэтажными работами.
// Правки — в те же связи; даты графика меняет «Пересчитать график».
import { useEffect, useRef, useState } from 'react';
import type { ShellCtx } from '../shell';
import { Links } from './Links';

/** раскатки, у которых задача есть на каждом типовом этаже */
const POETAZHNYE = new Set(['этажи', 'секции', 'квартиры']);

export function TipovojEtazh({ ctx, busy, onRecalc, onClose }: {
  ctx: ShellCtx; busy: boolean; onRecalc: () => void; onClose: () => void;
}) {
  // панель прижата к низу окна, слева — по краю экрана модели, а не поверх меню
  const koren = useRef<HTMLDivElement>(null);
  const [levo, setLevo] = useState(0);
  useEffect(() => {
    const el = koren.current?.parentElement;
    if (!el) return;
    const f = () => setLevo(Math.max(0, el.getBoundingClientRect().left));
    f();
    window.addEventListener('resize', f);
    const ro = new ResizeObserver(f);
    ro.observe(el);
    return () => { window.removeEventListener('resize', f); ro.disconnect(); };
  }, []);


  return (
    <div ref={koren} className="te" style={{ left: levo }}>
      <div className="te-shapka">
        <b>Связи</b>
        <span className="pw-muted">работы по типовым этажам дорожками по контуру планирования; связи — как на экране «Связи»</span>
        <span className="grow" />
        {ctx.canPlan && <button className="sec" disabled={busy}
          title="Пересчитать даты всех задач проекта после правки связей"
          onClick={onRecalc}>{busy ? 'Считаю…' : 'Пересчитать график'}</button>}
        <button className="sec" title="Закрыть" aria-label="Закрыть" onClick={onClose}>✕</button>
      </div>
      <div className="te-telo">
        {/* фильтры графика сверху действуют и здесь, как на «Связях» (владелец 2026-10-05):
            подходящие работы ярко, их соседи по связям — бледно */}
        <Links ctx={ctx} tolkoRaskatki={POETAZHNYE} vysota="calc(50vh - 70px)" dorozhki="kontur" />
      </div>
    </div>
  );
}
